import './event-sponsors.scss';
import type { EventRecord } from '../../helpers/eventHelpers';
import { getEventSponsorLogo } from '../../helpers/eventHelpers';

type EventSponsorsProps = {
  event: EventRecord;
  calendarStyle?: boolean;
};

const EventSponsors = ({ event, calendarStyle = false }: EventSponsorsProps) => {
  if (!event.sponsors?.length) {
    return null;
  }

  const prefix = calendarStyle ? 'meeting-calendar__event-sponsors' : 'event-sponsors';
  const itemClass = calendarStyle ? 'meeting-calendar__event-sponsor' : 'event-sponsors__item';
  const logoClass = calendarStyle ? 'meeting-calendar__event-sponsor-logo' : 'event-sponsors__logo';
  const nameClass = calendarStyle ? 'meeting-calendar__event-sponsor-name' : 'event-sponsors__name';
  const entryClass = calendarStyle ? 'meeting-calendar__event-sponsor-entry' : 'event-sponsors__entry';

  return (
    <div className={prefix} aria-label="Event sponsors">
      <span className={`${prefix}-title`}>Event Sponsors</span>
      <div className={`${prefix}-list`}>
        <div className={itemClass}>
          {event.sponsors.map((sponsor) => {
            const logo = getEventSponsorLogo(event, sponsor.logo);
            const placeholderClass = `${logoClass}${calendarStyle ? ' meeting-calendar__event-sponsor-logo--placeholder' : ' event-sponsors__logo--placeholder'}`;

            return (
              <div className={entryClass} key={`${event.id}-${sponsor.name}`}>
                {logo ? (
                  <img src={logo} alt={sponsor.name} className={logoClass} />
                ) : (
                  <span className={placeholderClass}>Logo</span>
                )}
                <span className={nameClass}>{sponsor.abbreviation || sponsor.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EventSponsors;
